import { styled } from '@mui/material';

const StyledKnowledgeItems = styled('ul')`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & li {
    border: 1px solid rgba(15, 23, 42, 0.1);
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    background-color: #ffffff;

    & > *:last-child {
      flex-shrink: 0;
      white-space: nowrap;
    }
  }
`;

export default StyledKnowledgeItems;
